import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Point } from 'types/building'
import Krpano from 'utils/krpano'

import useCommunityKrpano from '../hooks/useCommunityKrpano'

export default function CommunityPanorama() {
  const { id } = useParams()
  const {
    mutate: refreshPointList,
    currentPov,
    currentViewer,
    setCurrentViewer,
    setCurrentHgap,
    embedpano
  } = useCommunityKrpano()

  // get point detail when select point
  useSWR<Point>(
    currentViewer.selectedFloor && currentViewer.selectedPoint
      ? {
          url: `v1/tour/points/${currentViewer.selectedPoint}`,
          params: {
            building_id: id,
            floor_id: currentViewer?.selectedFloor
          }
        }
      : null,
    {
      onSuccess: (data) => {
        setCurrentViewer((prev) => ({
          ...prev,
          selectedPoint: data.id,
          pointDetail: data,
          selectedImage: data.image360?.id
        }))
        if (data.image360) {
          const pov = currentViewer.isClickToDirection
            ? currentPov
            : data.initView
          const currentChooseImage = sessionStorage.getItem(data.id)
          !currentChooseImage && sessionStorage.setItem(data.id, 'main')
          const image360 =
            !currentChooseImage || currentChooseImage === 'main'
              ? data.image360
              : data?.subImages?.find(
                  (item) => `${item.id}` === currentChooseImage
                )
          const initProps = {
            imageUrl: image360?.s3Path || '',
            previewUrl: data.image360?.multires
              ? `${data.image360?.tilesUrl}preview.jpg`
              : data.image360?.thumbnail || '',
            hgap: data.initView.radarHGap,
            multires: data.image360.multires,
            tilesUrl: data.image360.tilesUrl,
            ...(pov || data.initView)
          }
          setCurrentHgap(initProps.hgap)

          const annotations = data.annotations?.filter((item: any) => {
            return !item.imageID || item.imageID === data.image360?.id
          })

          embedpano(
            initProps,
            annotations,
            data.directions,
            data.stairways,
            data
          )
        } else {
          Krpano.UnmountPanoViewer()
        }
      },
      onError: () => {
        refreshPointList()
      }
    }
  )

  return <div id="viewer-pano-container" className="w-full h-screen" />
}
